import React, { useState } from "react";
import axios from "axios";
import { refreshToken } from "../utils/auth";
import "../styles/TopUpModal.css"; 

const API_URL = process.env.REACT_APP_API_URL;
const QUICK_AMOUNTS = [50, 100, 250,];

const TopUpModal = ({ onClose, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const validateInputs = () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      return "Enter a valid deposit amount greater than 0";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let token = localStorage.getItem("token");
    setError("");
    setStatus("");

    const validationError = validateInputs();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      setLoading(true);
      setStatus("Initiating STK push...");

      let res;
      try {
        res = await axios.post(
          `${API_URL}/api/deposits`,
          { amount },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (err) {
        if (err.response?.status === 401) {
          const newToken = await refreshToken();
          if (newToken) {
            res = await axios.post(
              `${API_URL}/api/deposits`,
              { amount },
              { headers: { Authorization: `Bearer ${newToken}` } }
            );
          } else {
            throw err;
          }
        } else {
          throw err;
        }
      }

      if (res.data.success) {
        setStatus("STK push sent. Check your phone and enter PIN...");
      } else {
        setError(res.data.message || "Failed to start deposit");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = async () => {
    // Refresh wallet balance on modal close
    let token = localStorage.getItem("token");
    try {
      let walletRes;
      try {
        walletRes = await axios.get(`${API_URL}/api/user`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      } catch (err) {
        if (err.response?.status === 401) {
          const newToken = await refreshToken();
          if (newToken) {
            walletRes = await axios.get(`${API_URL}/api/user`, {
              headers: { Authorization: `Bearer ${newToken}` },
            });
          } else {
            throw err;
          }
        } else {
          throw err;
        }
      }

      if (onSuccess && walletRes.data.wallet !== undefined) {
        onSuccess(walletRes.data.wallet);
      }
    } catch (err) {
      alert("Failed to refresh account. Reload the page");
    } finally {
      onClose();
    }
  };

  return (
    <div className="topup-modal-overlay">
      <div className="topup-modal-box">
        <button className="topup-modal-close" onClick={handleClose}>×</button>
        <h2 className="topup-modal-title">Deposit to Wallet</h2>
        <p className="topup-modal-info">
          STK Push will be sent to your registered phone number.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-5">
          {QUICK_AMOUNTS.map((value) => (
            <button
              key={value}
              type="button"
              className={`
                px-6 py-3 rounded-xl font-semibold text-sm border-none transition-all duration-200 shadow-sm
                ${
                  Number(amount) === value
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }
              `}
              onClick={() => setAmount(value)}
            >
              KSh {value}
            </button>
          ))}
        </div>
        <form className="topup-modal-form" onSubmit={handleSubmit}>
          <label className="topup-modal-label">Amount</label>
          <input
            type="number"
            className="topup-modal-input"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            min="1"
          />

          {error && <p className="topup-modal-error">{error}</p>}
          {status && <p className="topup-modal-status">{status}</p>}

          <button
            type="submit"
            className="topup-modal-submit"
            disabled={loading || !amount || Number(amount) <= 0}
          >
            {loading ? "Processing..." : "Deposit"}
          </button>
        </form>
        <p className="text-xs text-red-500">Don't cancel this modal until payment is successful</p>
      </div>
    </div>
  );
};

export default TopUpModal;